var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnetoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M16.5 19h-10c-.827 0-1.5-.673-1.5-1.5v-15C5 1.673 5.673 1 6.5 1h10c.827 0 1.5.673 1.5 1.5v15c0 .827-.673 1.5-1.5 1.5zM6.5 2a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE4BD5",
    d: "M18.438 7H18V3h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9332BF",
    d: "M18.438 12H18V8h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    d: "M18.438 17H18v-4h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.5 18h10a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5h-10a.5.5 0 00-.5.5v15a.5.5 0 00.5.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    d: "M2 16h8a1 1 0 001-1V7a1 1 0 00-1-1H2a1 1 0 00-1 1v8a1 1 0 001 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 14H7.604S3.995 9.317 4 9.312V14H3V8h1.27S7.898 12.662 8 12.828V8h1v6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetoc);
export default __webpack_public_path__ + "static/media/onetoc.33f77491b124b8b3a74606d4c0a16e24.svg";
export { ForwardRef as ReactComponent };